import axios from '../utils/axios';

export default function add(adminId, data) {
    return axios.post('/admin/' + adminId + '/xml-feeds/excluded-users', data)
}

